import { ref, computed, onMounted, onUnmounted } from 'vue'

export function useVersionMovil(breakpoint = 768) {
    const windowWidth = ref(typeof window !== 'undefined' ? window.innerWidth : 768)

    const handleResize = () => {
        if (typeof window !== 'undefined') {
            windowWidth.value = window.innerWidth
        }
    }

    onMounted(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', handleResize)
        }
    })

    onUnmounted(() => {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', handleResize)
        }
    })

    const esMovil = computed(() => {
        return windowWidth.value <= breakpoint
    })

    return {
        esMovil
    }
}
